import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated, admin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header" data-testid="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo" data-testid="logo">
            <h1 className="logo-text">Velonity</h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav" data-testid="desktop-nav">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link 
              to="/services" 
              className={`nav-link ${isActive('/services') ? 'active' : ''}`}
              data-testid="nav-services"
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              data-testid="nav-about"
            >
              About
            </Link>
            <Link 
              to="/background-check" 
              className="nav-link nav-cta"
              data-testid="nav-background-check"
            >
              Background Check
            </Link>
            {isAuthenticated ? (
              <div className="admin-menu">
                <button className="admin-menu-btn" data-testid="admin-menu-btn">
                  {admin?.name || 'Admin'}
                  <ChevronDown size={16} />
                </button>
                <div className="admin-dropdown">
                  <Link to="/admin/dashboard" data-testid="nav-dashboard">Dashboard</Link>
                  <button onClick={handleLogout} data-testid="logout-btn">Logout</button>
                </div>
              </div>
            ) : (
              <Link 
                to="/admin/login" 
                className="nav-link"
                data-testid="nav-admin-login"
              >
                Admin
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="mobile-nav" data-testid="mobile-nav">
            <Link 
              to="/" 
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/services" 
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/background-check" 
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Background Check
            </Link>
            {isAuthenticated ? (
              <>
                <Link 
                  to="/admin/dashboard" 
                  className="mobile-nav-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Dashboard
                </Link>
                <button 
                  onClick={() => {
                    handleLogout();
                    setMobileMenuOpen(false);
                  }}
                  className="mobile-nav-link"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link 
                to="/admin/login" 
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Admin Login
              </Link>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
